import translations from './iron.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/iron'

export const iron: Metal = {
  id: 1,
  slug: 'iron',
  name: t.name,
  symbol: 'Fe',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Carajás mountains, iron mines (Brazil)',
      region: 'Carajás mountains',
      coordinates: [-50.16, -6.06],
    },
    {
      name: 'Newman, iron mines (Australia)',
      region: 'Newman',
      coordinates: [119.73, -23.36],
    },
    {
      name: 'Tom Price, iron mines (Australia)',
      region: 'Tom Price',
      coordinates: [117.79, -22.69],
    },
    {
      name: 'Gubkin, iron mines (Russia)',
      region: 'Gubkin',
      coordinates: [37.55, 51.28],
    },
  ],
  countries: [
    { name: 'Australia', percent: 37.2 },
    { name: 'Brazil', percent: 17.6 },
    { name: 'China', percent: 10.8 },
    { name: 'India', percent: 10.8 },
    { name: 'Russia', percent: 3.6 },
    { name: 'Iran', percent: 3.6 },
    { name: 'South Africa', percent: 2.6 },
  ],
  content: {
    smartphone: {
      quantityScore: 5,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 2, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 4, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
